import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import { accountApiResponseSuccess, accountApiResponseError } from './actions';
import { AccountActionTypes } from './constants';
import config from '../../config';
import { toggleLoading } from '../actions';
import {
    createAccount as createAccountApi,
    getAccount as getAccountApi,
    getUserAccounts as getUserAccountsApi,
    getOrganizationAccounts as getOrganizationAccountsApi,
    updateAccount as updateAccountApi,
    deleteAccount as deleteAccountApi
} from '../../helpers';

// Import the API helpers
// This is needed for a work-around due to 401 errors
import { APICore } from '../../helpers/api/apiCore';

const api = new APICore();

/**
 * Create a new account
 * @param {object} action
 * @param {string} action.payload
 * @param {string} action.payload.account
 * @param {object} action.payload.data
 */
function* createAccount({ payload: { data } }) {
    // yield put(toggleLoading(true));
    try {
        const response = yield call(createAccountApi, { data });
        yield put(accountApiResponseSuccess(AccountActionTypes.CREATE_ACCOUNT, response.data));
    } catch (error) {
        console.log(error);
        yield put(accountApiResponseError(AccountActionTypes.CREATE_ACCOUNT, error));
    }
    // yield put(toggleLoading(false)) is reloading the state which makes the call to
    // Accounts/reducer without an action, by default will assign createSuccess to null.

    // yield put(toggleLoading(false));
}

/**
 * Get Accounts
 * @param {object} action
 * @param {string} action.payload
 * @param {string} action.payload.page
 * @param {string} action.payload.limit
 * @param {string} action.payload.sort
 * @param {string} action.payload.order
 * @param {string} action.payload.search
 * @param {string} action.payload.category
 */
// function* getAccounts({ payload = {} }) {
//     yield put(toggleLoading(true));
//     try {
//         payload = {
//             page: payload.page || 1,
//             limit: 12,
//             address_1: payload?.search?.address_1 ?? '',
//             zip: payload?.search?.zip ?? '',
//         };
//         let url = `${config.server.api}/v1/accounts?`;
//         Object.keys(payload).forEach((k) => {
//             if (payload[k] !== '') {
//                 url += `${k}=${payload[k]}&`;
//             }
//         });
//         const res = yield api.get(url);
//         yield put(accountApiResponseSuccess(AccountActionTypes.GET_ACCOUNTS, res.data));
//     } catch (error) {
//         console.log(error);
//         yield put(accountApiResponseError(AccountActionTypes.GET_ACCOUNTS, error));
//     }
//     yield put(toggleLoading(false));
// }

/**
 * Get account by ID
 * @param {*} param0
 */
function* getAccount({ payload: { id } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(getAccountApi, { id });
        yield put(accountApiResponseSuccess(AccountActionTypes.GET_ACCOUNT_BY_ID, response.data));
    } catch (error) {
        console.log(error);
        yield put(accountApiResponseError(AccountActionTypes.GET_ACCOUNT_BY_ID, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Get accounts by user
 * @param {*} param0
 */
function* getUserAccounts({ payload: { user } }) {
    console.log("***Get Accounts By User***")
    yield put(toggleLoading(true));
    try {
        const response = yield call(getUserAccountsApi, { user });
        yield put(accountApiResponseSuccess(AccountActionTypes.GET_ACCOUNTS_BY_USER, response.data));
    } catch (error) {
        console.log(error);
        yield put(accountApiResponseError(AccountActionTypes.GET_ACCOUNTS_BY_USER, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Get accounts by user
 * @param {*} param0
 */
function* getOrganizationAccounts({ payload: { user } }) {
    console.log("***Get Accounts By Org***")
    yield put(toggleLoading(true));
    try {
        const response = yield call(getOrganizationAccountsApi, { user });
        yield put(accountApiResponseSuccess(AccountActionTypes.GET_ACCOUNTS_BY_ORGANIZATION, response.data));
    } catch (error) {
        console.log(error);
        yield put(accountApiResponseError(AccountActionTypes.GET_ACCOUNTS_BY_ORGANIZATION, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Update an account
 */
function* updateAccount({ payload: { id, data } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(updateAccountApi, { id, data });
        yield put(accountApiResponseSuccess(AccountActionTypes.UPDATE_ACCOUNT, response.data));
    } catch (error) {
        console.log(error);
        yield put(accountApiResponseError(AccountActionTypes.UPDATE_ACCOUNT, error));
    }
    yield put(toggleLoading(false));
}

/**
 * Delete an account
 */
function* deleteAccount({ payload: { id, data } }) {
    yield put(toggleLoading(true));
    try {
        const response = yield call(deleteAccountApi, { id, data });
        yield put(accountApiResponseSuccess(AccountActionTypes.DELETE_ACCOUNT, response.data));
    } catch (error) {
        console.log(error);
        yield put(accountApiResponseError(AccountActionTypes.DELETE_ACCOUNT, error));
    }
    yield put(toggleLoading(false));
}

// /**
//  * Get access by account
//  * @param {*} param0
//  * @param {*} param0.payload
//  * @param {*} param0.payload.id
//  * @param {*} param0.payload.data
//  */
// function* getAccessByAccount({ payload: { id, data } }) {
//     yield put(toggleLoading(true));
//     try {
//         const response = yield call(getAccessByAccountApi, { id, data });
//         yield put(accountApiResponseSuccess(AccountActionTypes.GET_ACCOUNT_ACCESS, response.data));
//     } catch (error) {
//         console.log(error);
//         yield put(accountApiResponseError(AccountActionTypes.GET_ACCOUNT_ACCESS, error));
//     }
//     yield put(toggleLoading(false));
// }

// /**
//  * Revoke access by account
//  * @param {*} param0
//  * @param {*} param0.payload
//  * @param {*} param0.payload.id
//  * @param {*} param0.payload.data
//  */
// function* revokeAccessByAccount({ payload: { id, data } }) {
//     yield put(toggleLoading(true));
//     try {
//         const response = yield call(revokeAccessByAccountApi, { id, data });
//         yield put(accountApiResponseSuccess(AccountActionTypes.REVOKE_ACCOUNT_ACCESS, response.data));
//     } catch (error) {
//         console.log(error);
//         yield put(accountApiResponseError(AccountActionTypes.REVOKE_ACCOUNT_ACCESS, error));
//     }
//     yield put(toggleLoading(false));
// }

export function* watchCreateAccount() {
    yield takeEvery(AccountActionTypes.CREATE_ACCOUNT, createAccount);
}

// export function* watchGetAccounts() {
//     yield takeEvery(AccountActionTypes.GET_ACCOUNTS, getAccounts);
// }

export function* watchGetAccount() {
    yield takeEvery(AccountActionTypes.GET_ACCOUNT_BY_ID, getAccount);
}

export function* watchGetUserAccounts() {
    yield takeEvery(AccountActionTypes.GET_ACCOUNTS_BY_USER, getUserAccounts);
}

export function* watchGetOrganizationAccounts() {
    yield takeEvery(AccountActionTypes.GET_ACCOUNTS_BY_ORGANIZATION, getOrganizationAccounts);
}

export function* watchUpdateAccount() {
    yield takeEvery(AccountActionTypes.UPDATE_ACCOUNT, updateAccount);
}

export function* watchDeleteAccount() {
    yield takeEvery(AccountActionTypes.DELETE_ACCOUNT, deleteAccount);
}

// export function* watchGetAccessByAccount() {
//     yield takeEvery(AccountActionTypes.GET_ACCOUNT_ACCESS, getAccessByAccount);
// }

// export function* watchRevokeAccessByAccount() {
//     yield takeEvery(AccountActionTypes.REVOKE_ACCOUNT_ACCESS, revokeAccessByAccount);
// }

function* accountSaga() {
    yield all([
        fork(watchCreateAccount),
        // fork(watchGetAccounts),
        fork(watchGetAccount),
        fork(watchGetUserAccounts),
        fork(watchGetOrganizationAccounts),
        fork(watchUpdateAccount),
        fork(watchDeleteAccount),
        // fork(watchGetAccessByAccount),
        // fork(watchRevokeAccessByAccount),
    ]);
}

export default accountSaga;
